// ─────────────────────────────────────────────────────────────────────
// DESIGN TOKENS
// ─────────────────────────────────────────────────────────────────────
export const T = {
  page:"#f1f5f9", surface:"#ffffff", sub:"#f8fafc",
  navy:"#0d1f3c", navyMid:"#1e293b", slate:"#334155",
  slateL:"#64748b", muted:"#94a3b8", line:"#e2e8f0",
  blue:"#0891b2", blueL:"#e0f2fe", cyan:"#06b6d4", cyanD:"#0e7490",
  green:"#059669", greenL:"#d1fae5",
  amber:"#d97706", amberL:"#fef3c7",
  red:"#dc2626", redL:"#fee2e2",
  purple:"#7c3aed", purpleL:"#ede9fe",
  orange:"#ea580c", orangeL:"#ffedd5",
  white:"#ffffff", text:"#0d1f3c", textS:"#475569",
};

// ─────────────────────────────────────────────────────────────────────
// GLOBAL CSS
// ─────────────────────────────────────────────────────────────────────
export const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Sora:wght@700;800&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}
body{background:#f1f5f9;font-family:'Inter','DM Sans',sans-serif;}
input,select,textarea,button{font-family:inherit;}

@keyframes fadeUp   {from{opacity:0;transform:translateY(22px);}to{opacity:1;transform:translateY(0);}}
@keyframes fadeIn   {from{opacity:0;}to{opacity:1;}}
@keyframes ping     {0%{transform:scale(1);opacity:0.9;}100%{transform:scale(2.2);opacity:0;}}
@keyframes slideIn  {from{opacity:0;transform:translateX(-16px);}to{opacity:1;transform:translateX(0);}}
@keyframes pulse    {0%,100%{opacity:1;}50%{opacity:0.5;}}
@keyframes float    {0%,100%{transform:translateY(0);}50%{transform:translateY(-8px);}}
@keyframes spin     {from{transform:rotate(0deg);}to{transform:rotate(360deg);}}
@keyframes shimmer  {0%{background-position:-400px 0;}100%{background-position:400px 0;}}

.fade-up  {animation:fadeUp  0.6s ease both;}
.fade-in  {animation:fadeIn  0.5s ease both;}
.slide-in {animation:slideIn 0.5s ease both;}
.float    {animation:float   3s ease-in-out infinite;}
.ping-anim{animation:ping    1.4s ease-out infinite;}
.pulse    {animation:pulse   2s ease infinite;}

/* Delay utilities */
.d1{animation-delay:0.1s;} .d2{animation-delay:0.2s;} .d3{animation-delay:0.3s;}
.d4{animation-delay:0.4s;} .d5{animation-delay:0.5s;} .d6{animation-delay:0.6s;}

/* Hover lift */
.lift{transition:transform 0.2s,box-shadow 0.2s;}
.lift:hover{transform:translateY(-3px);box-shadow:0 12px 32px rgba(0,0,0,0.12);}

/* Responsive grid helpers */
@media(max-width:900px){
  .hero-grid{grid-template-columns:1fr!important;}
  .g3col{grid-template-columns:1fr 1fr!important;}
  .g4col{grid-template-columns:1fr 1fr!important;}
  .hide-md{display:none!important;}
  .hero-title{font-size:clamp(28px,6vw,44px)!important;}
}
@media(max-width:600px){
  .g2col{grid-template-columns:1fr!important;}
  .g3col{grid-template-columns:1fr!important;}
  .g4col{grid-template-columns:1fr 1fr!important;}
  .pad-sm{padding:16px!important;}
  .hero-title{font-size:28px!important;}
  .mobile-full{width:100%!important;}
  .show-mobile{display:flex!important;}
  .hide-mobile{display:none!important;}
}
@media(min-width:601px){.show-mobile{display:none!important;}}

/* Scrollbar */
::-webkit-scrollbar{width:4px;height:4px;}
::-webkit-scrollbar-thumb{background:#cbd5e1;border-radius:99px;}

/* Map state hover */
.state-dot{transition:all 0.2s;cursor:pointer;}
.state-dot:hover{transform:scale(1.6);}
`;